import React,{ useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './cropContainer.css';
import { particularCropListRequest, cropPublishUnpublishRequest, cropSelectUnselectRequest, linkCropRequest, unlinkCropRequest} from '../../action';
import { removeDescription, removeMedia } from '../../action';
import { ToastContainer } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-modal';
import { seasonListRequest } from '../../../season/action';
import { growAreaListRequest } from '../../../growArea/action';
import CropImages from '../../../../images/images';

const customStyles = {
    content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)'
    }
};

const CropContainer = (props) => {
    const [modalIsOpen,setIsOpen] = React.useState(false);
    const [selectedCrop, setSelectedCrop] = React.useState('');
    const [_localBadgePopupOpen, _setLocalBadgePopupOpen] = React.useState(false);

    // If parent passes setOpenBadgePopupId, use parent-controlled state so only one popup is open at a time
    const badgePopupOpen = 'setOpenBadgePopupId' in props
        ? props.openBadgePopupId === props.data?.id
        : _localBadgePopupOpen;
    const setBadgePopupOpen = 'setOpenBadgePopupId' in props
        ? (val) => props.setOpenBadgePopupId(val ? props.data?.id : null)
        : _setLocalBadgePopupOpen;

    const badgePopupRef = useRef(null);

    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (badgePopupRef.current && !badgePopupRef.current.contains(e.target)) {
                setBadgePopupOpen(false);
            }
        };
        if (badgePopupOpen) {
            document.addEventListener('mousedown', handleOutsideClick);
        }
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [badgePopupOpen]);
    const getInitialChecked = () => {
        const productName = props.data?.product_names;
        if (!productName) return [];
        // If it's an array of product objects [{id, product_name}, ...]
        if (Array.isArray(productName)) {
            return productName.map(p => p.id).filter(Boolean);
        }
        // If it's a plain string, match by name against project_list
        if (typeof productName === 'string' && props.project_list?.length > 0) {
            return props.project_list
                .filter(item => productName.toLowerCase().includes(item.product_name.toLowerCase()))
                .map(item => item.id);
        }
        return [];
    };

    const [checkedItems, setCheckedItems] = React.useState(getInitialChecked);
    const [loadingItemId, setLoadingItemId] = React.useState(null);

    useEffect(() => {
        setCheckedItems(getInitialChecked());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.data?.product_names, props.project_list]);

    useEffect(()=>{
        setSelectedCrop(selectedCrop);
    },[selectedCrop]);

    useEffect(() => {
        if (props.crop_link_loading === false && badgePopupOpen) {
            setBadgePopupOpen(false);
        }
        if (props.crop_link_loading === false) {
            setLoadingItemId(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.crop_link_loading]);

    const getLangContent = (language) => {
        let data =  props.language_list.findIndex((tempData)=>{
            return tempData.locale.includes(language) === true
        })
        if(data !== -1){
            return data;
        }
        else{
            return 0;
        }
    }

    const getLanguageContent = (language) => {
        let data =  props.language_list.filter((tempData)=>{
            return tempData.locale.includes(language) === true
        })
        if(data.length > 0){
            return data[0].locale;
        }
        else{
            return "en_EN";
        }
    }

    const openModal = () => {
        setIsOpen(true);
    }
    const closeModal = () => {
        setIsOpen(false);
    }

    var langContent = getLangContent(props.lang);
    var languageContent = getLanguageContent(props.lang);

    const selectUnselectCrop = (crop_id) => {
        props.selectedCropList(crop_id);
    }

    const handleBadgeClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setBadgePopupOpen(true);
    }

    const closeBadgePopup = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setBadgePopupOpen(false);
    }

    const seasonListRequest = (selected_crop_id) =>{
        let index = props.organization_list.findIndex((tmp)=>{return tmp.organisation === props.organization});

        let params = {
            organisation: props.organization,
            crop_id: selected_crop_id
        }
        if(index !== -1){
            const {latitude, longitude} = props.organization_list[index];
            if(latitude == null && longitude == null){
                params = {...params, ...{latitude: -3.3731, longitude: 29.9189}};
            }   
            else{
                params = {...params, ...{latitude: latitude, longitude: longitude}};
            }
        }
        else{
            params = {...params, ...{latitude: -3.3731, longitude: 29.9189}};
        }

        props.actions.seasonListRequest(params);
    }

    const getEnglishIndex = (data) => {
        let temp = Object.values(data).findIndex((tmp)=>{
            //return tmp.locale.includes(props.lang);
            return tmp.locale.includes('en_EN');
        });
        return temp;    
    }

    return (
            props.generic === false ?
                <div 
                    className="cardContainer1"
                    onClick={()=>{props.actions.particularCropListRequest({
                        crop_id: 0,
                        locale: languageContent,
                        organisation: props.organization
                    })}}
                >
                    <div className="cardImageContainer">
                        <div className="cropImage">
                        </div>
                    </div>
                    <div className="cardNameContainer1">
                        <span>Generic Crop</span>
                    </div>
                </div>
            :
                <div 
                    className="cardContainer1"
                    style={{position:'relative'}}
                    onClick={()=>{

                        "modalOpen" in props === false ?
                            props.actions.particularCropListRequest({
                                crop_id: props.data.id,
                                locale: languageContent,
                                organisation: props.organization
                            })
                        :
                            selectUnselectCrop(props.data.id)

                            "modalOpen" in props === false &&
                                seasonListRequest(props.data.id); 
                            
                            "modalOpen" in props === false &&
                                props.actions.growAreaListRequest({"organisation": props.organization})
                        
                    }}
                >
                    {/* Top-left badge */}
                    <div
                        style={{
                            position: 'absolute',
                            top: -4,
                            left: -6,
                            zIndex: 10,
                            backgroundColor: '#4CBA6A',
                            color: '#fff',
                            borderRadius: '50%',
                            width: 30,
                            height: 30,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: 11,
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            boxShadow: '0 1px 4px rgba(0,0,0,0.25)'
                        }}
                        onClick={handleBadgeClick}
                        title="View list"
                    >
                        {checkedItems.length}
                    </div>

                    {/* Badge popup */}
                    {badgePopupOpen && (
                        <div
                            ref={badgePopupRef}
                            style={{
                                position: 'absolute',
                                top: 34,
                                left: 0,
                                zIndex: 100,
                                backgroundColor: '#fff',
                                border: '1px solid #ddd',
                                borderRadius: 6,
                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                padding: '10px 14px',
                                minWidth: 140,
                            }}
                            onClick={(e) => { e.stopPropagation(); }}
                        >
                            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 8 }}>
                                <span
                                    style={{ cursor: 'pointer', fontSize: 16, color: '#888', lineHeight: 1 }}
                                    onClick={closeBadgePopup}
                                >
                                    ×
                                </span>
                            </div>
                            { 
                                props.project_list &&
                                Object.values(props.project_list).length > 0 &&
                                    Object.values(props.project_list).map(item => (
                                        <div
                                            key={item.id}
                                            style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, cursor: loadingItemId === item.id ? 'not-allowed' : 'pointer', fontSize: 13 }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                if (loadingItemId !== null) return;
                                                const isSelected = checkedItems.includes(item.id);
                                                const newChecked = isSelected
                                                    ? checkedItems.filter(i => i !== item.id)
                                                    : [...checkedItems, item.id];
                                                setCheckedItems(newChecked);
                                                setLoadingItemId(item.id);
                                                if (isSelected) {
                                                    props.actions.unlinkCropRequest({
                                                        product_id: item.id,
                                                        crop_id: props.data.id
                                                    });
                                                } else {
                                                    props.actions.linkCropRequest({
                                                        product_id: item.id,
                                                        crop_ids: [props.data.id]
                                                    });
                                                }
                                            }}
                                        >
                                            {loadingItemId === item.id ? (
                                                <span style={{
                                                    width: 16,
                                                    height: 16,
                                                    border: '2px solid #4CBA6A',
                                                    borderTopColor: 'transparent',
                                                    borderRadius: '50%',
                                                    display: 'inline-block',
                                                    flexShrink: 0,
                                                    animation: 'spin 0.7s linear infinite',
                                                }} />
                                            ) : (
                                                <span
                                                    style={{
                                                        width: 16,
                                                        height: 16,
                                                        borderRadius: 3,
                                                        border: checkedItems.includes(item.id) ? '2px solid #4CBA6A' : '2px solid #aaa',
                                                        backgroundColor: checkedItems.includes(item.id) ? '#4CBA6A' : '#fff',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        flexShrink: 0,
                                                        transition: 'all 0.15s',
                                                    }}
                                                >
                                                    {checkedItems.includes(item.id) && (
                                                        <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                                                            <path d="M1 4L3.5 6.5L9 1" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                                                        </svg>
                                                    )}
                                                </span>
                                            )}
                                            {item.product_name}
                                        </div>
                                    ))}
                        </div>
                    )}

                    <div className="cardImageContainer">
                        {
                            props.data.image !== null ?
                                !props.cropImageVisibility ?
                                    <div className="cardImageContainer">
                                        <div className="cropImage"></div>
                                    </div>
                                :
                                    props.data.id in CropImages ? 
                                        <img 
                                            src={CropImages[props.data.id]} 
                                            alt="crops"
                                            className="cropImage"
                                        />
                                    :
                                        <div className="cardImageContainer">
                                            <div className="cropImage"></div>
                                        </div>
                            :
                                <div className="cropImage"></div>
                        }
                    </div>
                    
                    {
                        props.selected_crop_list !== undefined &&
                            props.selected_crop_list.includes(props.data.id) === true &&
                                <div className="idSelectedContainer">
                                    <span>{props.data.id}</span>
                                </div>
                    }

                    {
                        props.data?.crop_settings !== undefined &&
                        props.data?.crop_settings.length > 0 &&
                            props.data?.crop_settings[0].status === true ?
                                "modalOpen" in props === false &&
                                    <div 
                                        className="idSelectedContainer"
                                        style={props.user_role_type === "Superuser" ? {pointer: 'cursor'} : {}}
                                        onClick={(e)=>{
                                            if( props.user_role_type === "Superuser"){
                                                e.stopPropagation()
                                                e.preventDefault()
                                                openModal();
                                                setSelectedCrop({
                                                    "id": props.data.id,
                                                    "crop": langContent in props.data.crop_text && props.data.crop_text[langContent].displayName ? props.data.crop_text[0].displayName : null,
                                                    "status": props.data.crop_settings[0].status
                                                })
                                            }
                                        }}
                                    >
                                        <span>{props.data.id}</span>
                                    </div>
                            :
                                "modalOpen" in props === false &&
                                    <div 
                                        className="idContainer"
                                        style={props.user_role_type === "Superuser" ? {pointer: 'cursor'} : {}}
                                        onClick={(e)=>{
                                            if( props.user_role_type === "Superuser"){
                                                e.stopPropagation()
                                                e.preventDefault()
                                                openModal();
                                                setSelectedCrop({
                                                    "id": props.data.id,
                                                    "crop": langContent in props.data.crop_text && props.data.crop_text[langContent].displayName ? props.data.crop_text[0].displayName : null,
                                                    "status": props.data.crop_settings[0].status
                                                })
                                            }
                                        }}
                                    >
                                        <span>{props.data.id}</span>
                                    </div>
                    } 

                    <div className="cardNameContainer1">
                        <span>
                        {
                            props.data.crop_text.length > 0 ?
                                //langContent in props.data.crop_text &&
                                    //props.data.crop_text[langContent].displayName ? props.data.crop_text[getEnglishIndex(props.data.crop_text)].displayName : null
                                    getEnglishIndex(props.data.crop_text) !== -1 ? props.data.crop_text[getEnglishIndex(props.data.crop_text)].displayName : null
                            :
                                null
                        }
                        </span>
                    </div>

                    <ToastContainer/>
                    
                    {
                        "modalOpen" in props === false &&
                            props.user_role_type === "Superuser" &&
                                <Modal
                                    isOpen={ modalIsOpen }
                                    onRequestClose={(e)=>{
                                        e.stopPropagation();
                                        e.preventDefault();
                                        closeModal()
                                    }}
                                    style={customStyles}
                                >
                                    <h4>Do you really want to {selectedCrop.status === false ? `publish` : `unpublish`} {!selectedCrop.crop  ? "crop" :  selectedCrop.crop} ?</h4>
                                    <div className="modalBox">
                                        <div className="leftModal">
                                            <div 
                                                className="modalButton"
                                                onClick={(e)=>{
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    props.actions.cropPublishUnpublishRequest({
                                                        "crop_id":  selectedCrop.id,
                                                        "status":  !selectedCrop.status,
                                                        "organisation": props.organization
                                                    })
                                                }}
                                            >
                                                Yes
                                            </div>
                                        </div>

                                        <div className="rightModal">
                                            <div 
                                                className="modalButton" 
                                                onClick={(e)=>{
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    closeModal()
                                                }}
                                            >
                                                No
                                            </div>
                                        </div>
                                    </div>
                                </Modal>
                    }
                </div>
    )
}

const mapStateToProps = state => {
    return {
        lang: state.lang.language,
        publish_message: state.crop.publish_message,
        publish_unpublish_loading: state.crop.publish_unpublish_loading,
        user_role_type: state.auth.user_role_type,
        language_list: state.lang.language_list,
        organization: state.auth.organization,
        organization_list: state.organization.organization_list,
        crop_link_loading: state.crop.crop_link_loading,
    };
};
function mapDispatchtoProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                particularCropListRequest,
                removeDescription,
                removeMedia,
                cropPublishUnpublishRequest,
                seasonListRequest,
                growAreaListRequest,
                cropSelectUnselectRequest,
                linkCropRequest,
                unlinkCropRequest,
            },
            dispatch
        )
    };
}

export default connect(
    mapStateToProps,
    mapDispatchtoProps
)(CropContainer);